<template>
  <a-card :style="{ marginBottom: '16px' }">
    <a-card-meta>
      <template #title>
        <a-row justify="space-between" type="flex">
          <a-col :lg="16" :md="16" :sm="24" :xl="16" :xs="24" :xxl="16">
            {{ title }}
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8" :xs="24" :xxl="8">
            <p class="news-details">
              {{ selectedStyle.categoryName }}
              &nbsp;&bull;&nbsp;
              {{ new Date(publishedDate) | moment("H:mm:ss &bull; DD.MM.yyyy r.") }}
            </p>
          </a-col>
        </a-row>
      </template>
      <div slot="description">
        <vue-markdown class="news-body">{{ content }}</vue-markdown>
        <p class="news-footer">
          &mdash;<br/>
          Życzymy bezawaryjnego korzystania z sieci akademickiej,<br/>
          {{ author }}
        </p>
      </div>
      <a-avatar slot="avatar" :style="selectedStyle.itemStyle" size="large">
        <a-icon
            :type="selectedStyle.icon"/>
      </a-avatar>
    </a-card-meta>
  </a-card>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  props: {
    title: String,
    author: String,
    publishedDate: String,
    content: String,
    newsType: String,
  },
  components: {
    "vue-markdown": VueMarkdown,
  },
  data() {
    return {
      selectedStyle: {
        icon: "robot",
        itemStyle: {verticalAlign: "middle"},
        categoryName: "Domyślna",
      },
      styles: {
        maintenance: {
          icon: "tool",
          itemStyle: {backgroundColor: "#75e30e", verticalAlign: "middle"},
          categoryName: "Prace techniczne",
        },
        notification: {
          icon: "notification",
          itemStyle: {backgroundColor: "#0a97fc", verticalAlign: "middle"},
          categoryName: "Ogłoszenie",
        },
        database: {
          icon: "database",
          itemStyle: {backgroundColor: "#fadf11", verticalAlign: "middle"},
          categoryName: "Baza danych",
        },
        software: {
          icon: "cluster",
          itemStyle: {backgroundColor: "#02d11a", verticalAlign: "middle"},
          categoryName: "Oprogramowanie",
        },
        experiment: {
          icon: "experiment",
          itemStyle: {backgroundColor: "#8909de", verticalAlign: "middle"},
          categoryName: "Eksperymentalne",
        },
        scheduled: {
          icon: "schedule",
          itemStyle: {backgroundColor: "#ed3700", verticalAlign: "middle"},
          categoryName: "Zaplanowane",
        },
      },
    };
  },
  mounted() {
    this.selectedStyle = this.styles[this.newsType.toLowerCase()];
  },
};
</script>

<style scoped>
.news-body {
  color: #454545;
}

.news-footer {
  font-style: italic;
  font-size: 0.8em;
}

.news-details {
  padding-top: 0.25em;
  color: #7d7d7d;
  font-size: 0.7em;
  text-align: right;
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>
